.content {
  padding-left: 16px;
}

.completeButton {
  margin-top: 32px;
}
